import { Controller } from "@hotwired/stimulus"

// Popup de soutien (café). Règles de douceur :
// - jamais pour un visiteur venu moins de 2 jours différents ;
// - au plus une fois tous les 30 jours (fermer = cliquer = reporté d'un mois) ;
// - apparaît après un délai, pas à l'arrivée sur la page.
// Chaque affichage/fermeture/clic est compté via un beacon (stats admin).
const VISITS_KEY = "support:visitDays" // { count, last: "YYYY-MM-DD" }
const LAST_ASK_KEY = "support:lastAsk" // timestamp ms
const MIN_VISIT_DAYS = 2
const ASK_INTERVAL_DAYS = 30
const SHOW_DELAY_MS = 15000

export default class extends Controller {
  static targets = ["modal"]
  static values = { url: String }

  connect() {
    try {
      this.trackVisitDay()
      if (!this.shouldAsk()) return
      this._timer = setTimeout(() => this.show(), SHOW_DELAY_MS)
    } catch (e) {}
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  trackVisitDay() {
    const today = new Date().toISOString().slice(0, 10)
    let visits = { count: 0, last: null }
    try { visits = JSON.parse(localStorage.getItem(VISITS_KEY)) || visits } catch (e) {}
    if (visits.last !== today) {
      visits.count = (visits.count || 0) + 1
      visits.last = today
      localStorage.setItem(VISITS_KEY, JSON.stringify(visits))
    }
    this.visitDays = visits.count
  }

  shouldAsk() {
    // Pas de double sollicitation : tant que la campagne bandeau est en
    // place (le bandeau est dans la page et réapparaît régulièrement),
    // la popup mensuelle se tait.
    if (document.querySelector('[data-controller~="banner"]')) return false
    if (this.visitDays < MIN_VISIT_DAYS) return false
    const last = parseInt(localStorage.getItem(LAST_ASK_KEY) || "0", 10)
    return Date.now() - last > ASK_INTERVAL_DAYS * 24 * 3600 * 1000
  }

  show() {
    localStorage.setItem(LAST_ASK_KEY, String(Date.now()))
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.beacon("shown")
  }

  dismiss() {
    this.close()
    this.beacon("dismissed")
  }

  // Le lien s'ouvre dans un nouvel onglet (href) ; on compte et on ferme.
  donate() {
    this.close()
    this.beacon("clicked")
  }

  // Clic sur le fond sombre uniquement (pas sur la carte blanche).
  backdrop(event) {
    if (event.target === this.modalTarget) this.dismiss()
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
  }

  beacon(event) {
    try { navigator.sendBeacon("/track/support", new URLSearchParams({ event })) } catch (e) {}
  }
}
